"use client";

import { Flex, FlexColumnAlignJustifyCenter } from "@/components/Flex";
import RepeatAutoFillGrid from "@/components/styled/div/RepeatAutoFillGrid";
import { examNameToUrlComponent, getImageLink } from "@/hooks/exams/utils";
import ExamCard from "../../components/ExamCard";
import { ALL_EXAM_TYPES } from "@knowt/syncing/hooks/exams/constants";
import { themeColors } from "@/utils/themeColors";
import { CSSProperties, useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import LinkWrapper from "@/components/wrappers/Link";
import { spacing } from "@/utils/spacing";
import { borderRadius } from "@/utils/borderRadius";
import CircularRectTextButton from "@/components/CircularButton/styled/CircularRectTextButton";
import Circular from "@/components/Circular";
import { useBreakPoints } from "@/hooks/styles/useBreakpoints";

const ViewAllButton = ({ href }: { href: string }) => {
    return (
        <LinkWrapper href={href}>
            <CircularRectTextButton
                component={"div"}
                style={{
                    gap: spacing.XS,
                    padding: `${spacing.XS} ${spacing.SM}`,
                    height: "4.2rem",
                    borderRadius: borderRadius.shortInput,
                    backgroundColor: themeColors.neutralWhite,
                }}>
                <p className="secondaryTextBold1">View all</p>
                <Circular radius="2.6rem" style={{ backgroundColor: themeColors.primary }}>
                    <ArrowRight size={15.6} strokeWidth={3} color={themeColors.primaryDark} />
                </Circular>
            </CircularRectTextButton>
        </LinkWrapper>
    );
};

export const ExamTypesSection = ({ length = ALL_EXAM_TYPES.length, hideViewAll = false, itemMinWidth = 27 }) => {
    const { xlDown } = useBreakPoints();
    const [displayCount, setDisplayCount] = useState(length);

    useEffect(() => {
        setDisplayCount(xlDown ? 8 : length);
    }, [xlDown, length]);

    const exams = ALL_EXAM_TYPES.slice(0, displayCount);

    const renderExams = () => {
        return exams.map((type, idx) => {
            const image = getImageLink(type);
            return (
                <ExamCard
                    key={idx}
                    exam={{ type, name: "", image, href: `/exams/${examNameToUrlComponent(type)}` }}
                    style={
                        {
                            flex: 1,
                            "--link-hover-color": themeColors.neutralBlack,
                        } as CSSProperties
                    }
                    title={`Knowt ${type} Hub`}
                />
            );
        });
    };

    return (
        <FlexColumnAlignJustifyCenter style={{ gap: "1.6rem", width: "100%" }}>
            {/* Responsive Grid */}
            <RepeatAutoFillGrid itemMinWidth={`${itemMinWidth}rem`} style={{ gap: "1.6rem 2.4rem" }}>
                {renderExams()}
            </RepeatAutoFillGrid>

            {!hideViewAll && (
                <Flex style={{ alignSelf: "flex-end" }}>
                    <ViewAllButton href="/exams" />
                </Flex>
            )}
        </FlexColumnAlignJustifyCenter>
    );
};
